import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ProductAction } from '@stores/product/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import type { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import ProductList, { type LotteryRecordListItem } from '../../../lotteryRecord/layout/h5/components/productList';
import { lotteryRecordMockList } from '../../../lotteryRecord/layout/h5/components/mock';

interface LotteryRecordSearchH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    product?: ProductAction;
    productList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any;
    navCurrentIndex?: any;
    navCurrentType?: any;
    navClick?: Function;
    ruleValue?: any;
}

interface LotteryRecordSearchH5State {
    loading: boolean;
    error: any;
    pageLoaded: boolean;
    downloadAppStatus: boolean;
    headerShowStatus: boolean;
    searchValue: string;
    navCurrentIndex: number;
}

@inject('app', 'site', 'user', 'product')
@observer
class LotteryRecordSearchH5Page extends BasePage<LotteryRecordSearchH5PageProps, LotteryRecordSearchH5State> {
    state: LotteryRecordSearchH5State = {
        loading: false,
        error: null,
        pageLoaded: false,
        downloadAppStatus: true,
        headerShowStatus: false,
        searchValue: '',
        navCurrentIndex: 0,
    };

    async componentDidMount() {
        const { site, location } = this.props;
        const params = new URLSearchParams(location.search);
        const isPreviewFrame = params.get('previewFrame') === '1';

        if (site) {
            this.setState(
                {
                    downloadAppStatus: site.getAppDownloadShowStatus(),
                    headerShowStatus: site.getShowHeader(),
                },
                () => {
                    site.setShowHeader(false);
                    site.setAppDownloadShowStatus(!isPreviewFrame);
                },
            );
        }

        document.title = '搜索';
        super.componentDidMount();
    }

    componentWillUnmount() {
        const { site } = this.props;
        const { headerShowStatus } = this.state;

        if (site) {
            site.setShowHeader(headerShowStatus);
        }

        document.title = '';
    }

    handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            searchValue: event.target.value,
        });
    };

    handleBack = () => {
        this.props.history.goBack();
    };

    handleTabClick = (navCurrentIndex: number) => {
        this.setState({
            navCurrentIndex,
        });
    };

    handleLotteryClick = (id: string) => {
        if (!id) return;
        this.props.history.push('/lottery');
    };

    getFilteredList = () => {
        const { searchValue, navCurrentIndex } = this.state;
        const keyword = searchValue.trim().toLowerCase();
        let list: LotteryRecordListItem[] = lotteryRecordMockList;

        if (navCurrentIndex === 1) {
            list = list.filter((item) => item.resultType === 'win');
        }

        if (navCurrentIndex === 2) {
            list = list.filter((item) => item.resultType === 'lose');
        }

        if (!keyword) {
            return list;
        }

        return list.filter((item) =>
            [item.title, item.tipText, item.resultText].some((text) => text.toLowerCase().includes(keyword)),
        );
    };

    render() {
        const { site } = this.props;
        const { searchValue, navCurrentIndex } = this.state;
        const downloadAppStatus = site?.appDownloadShowStatus ?? this.state.downloadAppStatus;
        const filteredList = this.getFilteredList();

        return (
            <div className={styles.wrapper} style={{ paddingTop: downloadAppStatus ? 55 : 0 }}>
                <div className={styles.searchHeader}>
                    <div className={styles.backButton} onClick={this.handleBack}>
                        <span className={styles.backArrow} />
                    </div>
                    <div className={styles.searchBox}>
                        <img
                            src={`${BASE_IMG_URL}/common/search.png`}
                            alt="search"
                            className={styles.searchIcon}
                        />
                        <input
                            type="text"
                            placeholder="搜索抽奖"
                            className={styles.searchInput}
                            value={searchValue}
                            onChange={this.handleSearchChange}
                        />
                    </div>
                </div>

                <div className={styles.tabRow}>
                    {['全部', '已中奖', '未中奖'].map((item, index) => {
                        const isActive = navCurrentIndex === index;

                        return (
                            <div
                                key={item}
                                className={styles.tabItem}
                                onClick={() => this.handleTabClick(index)}
                            >
                                <span className={isActive ? styles.tabTextActive : styles.tabText}>{item}</span>
                                {isActive && <div className={styles.tabLine} />}
                            </div>
                        );
                    })}
                </div>

                <div className={styles.resultWrap}>
                    <ProductList list={filteredList} onItemClick={this.handleLotteryClick} />
                </div>
            </div>
        );
    }
}

export default withRouter(LotteryRecordSearchH5Page);
